import { createContext } from '../../utils/create-context';
export const [EnvironmentContextProvider, useEnvironmentContext] = createContext({
    hookName: 'useEnvironmentContext',
    providerName: '<EnvironmentProvider />',
    strict: false,
    defaultValue: () => ({
        getRootNode: () => document,
        getDocument: () => document,
        getWindow: () => window,
    }),
});
